export const API_KEY = "xiwf6ZdXNwezA2F4qVqVeKD9Pc7SUK2t";

export const API_URL = "https://api.giphy.com/v1";

// For Local
// export const ENDPOINT = "http://localhost:8080";

// For Deno Deploy
export const ENDPOINT = "https://giffy-api.deno.dev";
